import { render, staticRenderFns } from "./ViewFunctionalSkills.vue?vue&type=template&id=2918379d"
import script from "./ViewFunctionalSkills.vue?vue&type=script&lang=js"
export * from "./ViewFunctionalSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ViewFunctionalSkills.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports